import { AdvancedSearch } from "../AdvancedSearch";
import { FreightCalculator } from "../FreightCalculator";
import { OrderQuoteButtonPanel } from "../OrderQuoteButtonPanel";
import { TableCustomerOrders } from "../TableCustomerOrders";
import { TableCustomerQuotes } from "../TableCustomerQuotes";
import { Layout, Switch, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCustomerPortal extends Layout {
    layoutAdvanceSearch: AdvancedSearch;
    layoutFreightCalculator: FreightCalculator;
    layoutOrderQuoteButtonPanel: OrderQuoteButtonPanel;
    layoutQuoteList: TableCustomerQuotes;
    switchListMapView: Switch;
    tabAdvancedSearch: Tab;
    tabAllOrders: Tab;
    tabDelivered: Tab;
    tabFreightCalculator: Tab;
    tabInTransit: Tab;
    tabQuotes: Tab;
    tabScheduled: Tab;
    tableAllOrders: TableCustomerOrders;
    tableDelivered: TableCustomerOrders;
    tableInTransit: TableCustomerOrders;
    tableScheduled: TableCustomerOrders;
    tabset: Tabset;
}
